import React from 'react';

import logo from '../../../static/logo_horizontal.png';
import * as ROUTE from 'constants/routes';

const Footer = ({ path }) => {
	// hide the footer to these routes
	const hiddenPaths = [
		ROUTE.SIGNIN,
		ROUTE.SIGNUP,
		ROUTE.FORGOT_PASSWORD,
		ROUTE.ACCOUNT,
		ROUTE.ACCOUNT_EDIT,
		ROUTE.CHECKOUT_STEP_1,
		ROUTE.CHECKOUT_STEP_2,
		ROUTE.CHECKOUT_STEP_3
	];

	return hiddenPaths.includes(path) ? null : (
		<footer className="footer">
			<div className="footer-col-1">
				<strong><span>Developed by <a href="http://www.aaronat1.com/">aaronat1</a></span></strong>
			</div>
			{/* <div className="footer-col-2">
				<img className="footer-logo" src={logo} />
			</div> */}
			<div className="footer-col-3">
				<h5>PescaSub Lanzarote &copy;&nbsp;{new Date().getFullYear()}</h5>
			</div>
		</footer>
	);
};

export default Footer;
